import { render, staticRenderFns } from "./Signup.vue?vue&type=template&id=024d905c"
import script from "./Signup.vue?vue&type=script&lang=ts"
export * from "./Signup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('024d905c')) {
      api.createRecord('024d905c', component.options)
    } else {
      api.reload('024d905c', component.options)
    }
    module.hot.accept("./Signup.vue?vue&type=template&id=024d905c", function () {
      api.rerender('024d905c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Signup.vue"
export default component.exports